"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ButtonGroup = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(ButtonGroup, _Component);

  var _super = _createSuper(ButtonGroup);

  function ButtonGroup() {
    var _this;

    (0, _classCallCheck2["default"])(this, ButtonGroup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(ButtonGroup, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.root, className, style)
      }, _react["default"].Children.map(children, function (child) {
        if (! /*#__PURE__*/_react["default"].isValidElement(child)) {
          return null;
        }

        return /*#__PURE__*/_react["default"].cloneElement(child, {
          borderRadius: 0,
          hideBorder: true
        });
      }));
    }
  }, {
    key: "styles",
    get: function get() {
      var borderPrimary = this.context.theming.theme.borderPrimary;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: "row",
          alignItems: "stretch",
          overflow: "hidden",
          borderRadius: 6,
          border: "solid 1px ".concat(borderPrimary),
          ":nth-child(1n) > *": {
            ":not(:last-child)": {
              borderRight: "solid 1px ".concat(borderPrimary)
            }
          }
        }
      });
    }
  }]);
  return ButtonGroup;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = {}, _class3.demoProps = {}, _class3.demoRender = "\n<ButtonGroup>\n  <Button text=\"Button 1\" onClick={() => {\n    const { toastStore } = app;\n    toastStore.info(\"You clicked Button1\");\n  }} />\n  <Button text=\"Button 2\" onClick={() => {\n    const { toastStore } = app;\n    toastStore.warning(\"You clicked Button2\");\n  }} />\n</ButtonGroup>\n  ", _class3.discussion = "\n    This component renders a set of buttons together, as a group. The buttons\n    are defined as child components.\n  ", _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = ButtonGroup;
exports["default"] = _default;